import { motion } from "framer-motion";
import {
  FaComments,
  FaDraftingCompass,
  FaHardHat,
  FaKey,
} from "react-icons/fa";

const WorkProcess = () => {
  const steps = [
    {
      number: "01",
      icon: <FaComments />,
      title: "Consultation",
      description:
        "We understand your requirements, project goals, budget and timeline to create the perfect roadmap.",
    },
    {
      number: "02",
      icon: <FaDraftingCompass />,
      title: "Planning & Design",
      description:
        "Our experts prepare project plans, designs, approvals and strategies before execution begins.",
    },
    {
      number: "03",
      icon: <FaHardHat />,
      title: "Construction & Execution",
      description:
        "Our skilled team executes the project using quality materials while maintaining timelines and standards.",
    },
    {
      number: "04",
      icon: <FaKey />,
      title: "Project Delivery",
      description:
        "After thorough quality checks, we deliver the completed project ready for use and occupancy.",
    },
  ];

  return (
    <section className="py-12 md:py-24 bg-slate-50 overflow-hidden">
      <div className="container-custom">

        {/* Heading */}

        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-20">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Our Process
          </span>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            How We Turn Your Vision
            <span className="text-[#F59E0B]"> Into Reality</span>
          </h2>

          <p className="text-gray-600 mt-6 leading-8">
            Our streamlined process ensures transparency,
            quality execution and timely project delivery.
          </p>

        </div>

        {/* Process Steps */}

        <div className="relative">

          {/* Desktop Connecting Line */}
          <div className="hidden lg:block absolute top-[60px] left-[12.5%] w-[75%] h-[3px]">
            <div className="absolute inset-0 bg-gradient-to-r from-[#082B57] via-[#F59E0B] to-[#082B57] rounded-full opacity-30" />
            {/* Animated pulse dot */}
            <motion.div
              className="absolute top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-[#F59E0B] shadow-lg shadow-[#F59E0B]/50"
              animate={{ left: ["0%", "100%", "0%"] }}
              transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
            />
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 relative">

            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{
                  opacity: 0,
                  y: 50,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.15,
                }}
                viewport={{ once: true }}
                className="relative text-center group"
              >
                {/* Icon Circle with Step Number Badge */}
                <div className="relative z-10 mx-auto w-fit">
                  {/* Main Icon Circle */}
                  <div className="w-[120px] h-[120px] mx-auto rounded-full bg-[#082B57] text-white flex items-center justify-center text-4xl shadow-xl group-hover:bg-[#F59E0B] transition-colors duration-500 relative">
                    {step.icon}
                    {/* Pulse ring */}
                    <div className="absolute inset-0 rounded-full border-2 border-[#082B57]/20 group-hover:border-[#F59E0B]/30 scale-110 transition-colors duration-500" />
                  </div>

                  {/* Step Number Badge */}
                  <div className="absolute -top-1 -right-1 w-10 h-10 rounded-full bg-[#F59E0B] text-white text-sm font-bold flex items-center justify-center shadow-lg shadow-[#F59E0B]/30 z-20 ring-4 ring-slate-50">
                    {step.number}
                  </div>
                </div>

                {/* Content Card */}

                <div className="mt-6 bg-white rounded-2xl p-6 sm:p-8 shadow-md border border-gray-100 hover:shadow-xl hover:-translate-y-2 transition-all duration-400 group-hover:border-[#F59E0B]/20">

                  <h3 className="text-lg sm:text-xl font-bold text-[#082B57] group-hover:text-[#F59E0B] transition-colors duration-300">
                    {step.title}
                  </h3>

                  <p className="text-gray-500 mt-3 leading-7 text-sm">
                    {step.description}
                  </p>

                </div>
              </motion.div>
            ))}

          </div>

        </div>

      </div>
    </section>
  );
};

export default WorkProcess;